import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

import { BaseApiService } from './base-api.service';
import { Account } from '../interfaces/account.interface';

@Injectable({
  providedIn: 'root',
})
export class AccountService extends BaseApiService {
  public async requestCurrent(): Promise<Account> {
    return await lastValueFrom(this.get<Account>('api/v1/account'));
  }
}
